import { primaryBackground } from '@assets/colors';
import { css } from '@emotion/css';

const getPadding = (padding) => {
  let strPadding = padding;
  if (typeof padding === 'number') {
    strPadding += 'px';
  }
  const splitPadding = strPadding.split(' ');
  switch (splitPadding.length) {
    case 1:
      return {
        top: splitPadding[0],
        bottom: splitPadding[0],
        left: splitPadding[0],
        right: splitPadding[0],
      };
    case 2:
      return {
        top: splitPadding[0],
        bottom: splitPadding[0],
        left: splitPadding[1],
        right: splitPadding[1],
      };
    case 3:
      return {
        top: splitPadding[0],
        bottom: splitPadding[2],
        left: splitPadding[1],
        right: splitPadding[1],
      };
    case 4:
      return {
        top: splitPadding[0],
        bottom: splitPadding[2],
        left: splitPadding[3],
        right: splitPadding[1],
      };
    case 0:
    default:
      return {
        top: '0px',
        bottom: '0px',
        left: '0px',
        right: '0px',
      };
  }
};

const getColWidth = (size) => {
  switch (true) {
    case size === 'auto':
      return 'auto';
    case Number.isInteger(size) && size >= 1 && size <= 12:
      return `calc(100% * ${size} / 12)`;
    default:
      return '100%';
  }
};

export const styCol = ({ size, maxSize, minSize }) => css`
  width: ${getColWidth(size)};
  ${maxSize && `max-width: ${getColWidth(maxSize)};`}
  ${minSize && `min-width: ${getColWidth(minSize)};`}
`;

const getRowAlign = (align) => {
  switch (align) {
    case 'top-left':
      return 'align-items: flex-start; justify-content: flex-start;';
    case 'left':
      return 'align-items: center; justify-content: flex-start;';
    case 'bottom-left':
      return 'align-items: flex-end; justify-content: flex-start;';
    case 'top':
      return 'align-items: flex-start; justify-content: center;';
    case 'center':
      return 'align-items: center; justify-content: center;';
    case 'bottom':
      return 'align-items: flex-end; justify-content: center;';
    case 'top-right':
      return 'align-items: flex-start; justify-content: flex-end;';
    case 'right':
      return 'align-items: center; justify-content: flex-end;';
    case 'bottom-right':
      return 'align-items: flex-end; justify-content: flex-end;';
    case 'top-between':
      return 'align-items: flex-start; justify-content: space-between;';
    case 'between':
      return 'align-items: center; justify-content: space-between;';
    case 'bottom-between':
      return 'align-items: flex-end; justify-content: space-between;';
    default:
      return 'align-items: center; justify-content: center;';
  }
};

export const styRow = (props) => {
  const padding = getPadding(props.padding);
  return css`
    display: flex;
    flex-direction: row;

    margin-top: 0;
    margin-bottom: 0;
    margin-left: ${props.noGutters ? '0' : `-${padding.left}`};
    margin-right: ${props.noGutters ? '0' : `-${padding.right}`};

    ${getRowAlign(props.align)}

    ${props.noGutters
      ? `
        > div {
          padding-top: 0;
          padding-bottom: 0;
          padding-left: 0;
          padding-right: 0;
        }
      `
      : `
        > div {
          padding-top: ${padding.top};
          padding-bottom: ${padding.bottom};
          padding-left: ${padding.left};
          padding-right: ${padding.right};
        }
      `}
    
    ${props.hover && `
      cursor: pointer;

      :hover {
        background-color: ${primaryBackground};
      }

      :focus {
        outline: 0;
        background-color: ${primaryBackground};
      }
    `}
  `;
};

export const styContainer = (props) => {
  const padding = getPadding(props.padding);
  return css`
    width: 100%;
    padding-top: ${padding.top};
    padding-bottom: ${padding.bottom};
    padding-left: ${padding.left};
    padding-right: ${padding.right};
    margin-left: auto;
    margin-right: auto;

    ${props.color && `background-color: ${props.color};`}
    ${props.scrollable === true && 'overflow: auto;'}
    ${props.scrollable === 'x' && 'overflow-x: auto;'}
    ${props.scrollable === 'y' && 'overflow-y: auto;'}
  `;
};
